var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 71,
    viewBox: "0 0 99 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5113 55.6536L45.034 53.0711H44.8604C43.1584 55.14 40.4968 56.2344 37.411 56.2344C32.0976 56.2344 28.978 52.4374 28.978 48.2901C28.978 41.5218 35.0581 38.3152 44.2866 38.3296V37.9984C44.2866 36.6159 43.5441 34.643 39.5084 34.6526C36.8517 34.6526 34.0552 35.5551 32.3194 36.5919L30.8247 31.4221C32.6424 30.3853 36.196 29.094 40.9645 29.094C49.6482 29.094 52.3966 34.2062 52.3966 40.3025V49.3605C52.3966 51.8374 52.5267 54.1943 52.8112 55.6488H45.5065L45.5113 55.6536ZM44.5277 43.3698C40.2606 43.3458 36.9626 44.3683 36.9626 47.4644C36.9626 49.5573 38.3368 50.575 40.1834 50.575C42.1651 50.575 43.8479 49.2549 44.3782 47.5892C44.5036 47.1716 44.5277 46.6676 44.5277 46.2116V43.3698Z",
    fill: "#6829DA",
    stroke: "#6829DA",
    strokeWidth: 0.204808,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2337 29.6797L68.1295 42.4483C68.5731 43.9699 69.0794 45.9092 69.4314 47.2725H69.6001C69.9618 45.8708 70.3764 43.9459 70.7573 42.4387L73.9733 29.6845H82.6281L76.5818 46.7829C72.8403 57.0937 70.3427 61.2123 67.3967 63.8092C64.6049 66.2429 61.6156 67.1406 59.5857 67.3614L57.8499 60.5547C58.8865 60.3579 60.1353 59.8874 61.3793 59.1818C62.6185 58.529 63.9637 57.2329 64.7207 55.9417C64.9955 55.5337 65.1739 55.1256 65.1739 54.78C65.1739 54.4776 65.1064 54.0888 64.8171 53.4456L55.2559 29.6845H64.2337V29.6797Z",
    fill: "#6829DA",
    stroke: "#6829DA",
    strokeWidth: 0.204808,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4024 22.4698C94.4121 24.7163 92.7438 26.5019 90.0437 26.5019C87.3436 26.5019 85.8103 24.7163 85.8248 22.4698C85.8152 20.1609 87.5172 18.428 90.116 18.428C92.7149 18.428 94.3735 20.1561 94.4024 22.4698ZM86.0514 55.6537V29.6797H94.1758V55.6537H86.0514Z",
    fill: "#6829DA",
    stroke: "#6829DA",
    strokeWidth: 0.204808,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5962 44.6708C20.6126 41.0947 19.0842 38.517 16.3744 37.4273V37.2449C19.7351 36.0448 23.2742 32.6127 23.2742 27.6829C23.2742 24.1067 21.9916 21.3706 19.6579 19.5273C16.8662 17.324 12.8064 16.4456 7.01088 16.4456C5.9887 16.4456 4.99063 16.4648 4.02148 16.4984V23.3003C4.64347 23.1419 5.88262 23.0075 7.99931 23.0075C12.035 23.0315 14.4892 24.8507 14.4892 28.4125C14.4892 31.9743 11.8662 34.0191 7.4834 34.0191H4.02148V40.3842H6.64926C10.2847 40.4322 11.9289 41.7283 13.0138 46.5909C14.1276 51.4055 15.1015 54.5353 15.6994 55.6585H24.7447C23.9781 54.1513 22.7968 49.0774 21.5914 44.6756L21.5962 44.6708Z",
    fill: "#6829DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83055 3.64676L3.90234 3.75122L4.14 12.6093L8.0682 12.5048L7.83055 3.64676Z",
    fill: "#EB8021"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9435 4.85415L14.1025 4.02808L12.2231 12.6895L16.0641 13.5156L17.9435 4.85415Z",
    fill: "#EB8021"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.461 10.856L25.4707 8.31787L19.6961 15.061L22.6864 17.5992L28.461 10.856Z",
    fill: "#EB8021"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6891 20.6308L33.1196 17.0442L24.9596 20.5833L26.5291 24.1699L34.6891 20.6308Z",
    fill: "#EB8021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f5bcf1091fff60a998849d85b29b74fa.svg";
export { ForwardRef as ReactComponent };